import {
    legacy_createStore,
    applyMiddleware,
    compose,
    combineReducers,
} from 'redux';
import thunk from 'redux-thunk';
import { authReducer } from './reducers/auth';
import { generalReducer } from './reducers/general';

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    }
}

const composeEnhancers =
    (window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] as typeof compose) ||
    compose;

const reducers = combineReducers({
    auth: authReducer,
    general: generalReducer,
});

export const store = legacy_createStore(
    reducers,
    composeEnhancers(applyMiddleware(thunk))
);

export type RootState = ReturnType<typeof store.getState>;
